import React from 'react';
import { Row } from 'react-bootstrap';
import {
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldSelectIsActive,
  FieldDateRanger,
  buildWhereForDates,
  FormCol3,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import {
  FieldSelectGroup,
  FieldSelectNomos,
  FormFieldMultiMaterialDlg,
  FieldSelectRegion,
} from 'shared-pages';

import {
  isAfisCyprus,
  isFotokiklosi,
  isMedicycle,
  isRebattery,
} from 'shared-pages/common/constants';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  console.log('$$$ values', values);
  if (values) {
    // comma separated values
    if (values.searchText) {
      const searchTerms = values.searchText
        .split(',')
        .map((term) => term.trim())
        .filter((term) => term !== '');

      if (searchTerms.length > 0) {
        where = {
          ...where,
          $and: searchTerms.map((term) => {
            const likeObj = { $like: `%${term}%` };
            return {
              $or: [
                { '$collectionpoint.code$': likeObj },
                { '$collectionpoint.name$': likeObj },
                { '$collectionpoint.companyVat$': likeObj },
                { '$collectionpoint.addressCity$': likeObj },
                { '$collectionpoint.addressArea$': likeObj },
                { '$collectionpoint.addressDescription$': likeObj },
              ],
            };
          }),
        };
      }
    }

    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, '$collectionpoint.isActive$': values.isActive };
    }
    if (values.groupId) {
      where = { ...where, '$collectionpoint.groupId$': values.groupId };
    }
    if (values.addressNomos) {
      where = { ...where, '$collectionpoint.addressNomos$': values.addressNomos };
    }
    if (values.regionId) {
      where = { ...where, '$collectionpoint.regionId$': values.regionId };
    }
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'lastCollectionDate'),
      };
      if (values.materialId) {
        where = {
          ...where,
          materialIds: values.materialId,
        };
      }
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false }) => {
  //
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    groupId: initialValues?.groupId ?? undefined,
    regionId: initialValues?.regionId ?? undefined,
    addressNomos: initialValues?.addressNomos ?? undefined,
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
    materialId: initialValues?.materialId ?? undefined,
    materialName: initialValues?.materialName ?? '',
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση (Επωνυμία, Κωδικός, Περιοχή, Πόλη, Περιγραφή)')}
          type="search"
          placeholder={t('Πολλοί όροι χωρισμένοι με κόμμα')}
          disable={disable}
        />
        <FieldSelectGroup as={FormCol} label="Κατηγορία" name="groupId" />
        <FieldSelectNomos as={FormCol} />
        <FieldSelectRegion as={FormCol} />
        <FieldDateRanger as={FormCol} label="Τελευταία Συλλογή από" name="startDate" name2="endDate" />
        <FormFieldMultiMaterialDlg
          label={t('Απόβλητα')}
          as={FormCol3}
          initValueName={filters.materialName}
          initValueId={filters.materialId}
          onValueChange={(valueId, valueName) => {
            filters.materialId = valueId;
            filters.materialName = valueName;
          }}
          initFilters={{ isActive: true }}
          disable={disable}
        />
        <FieldSelectIsActive label={t('Ενεργά Σημεία')} disable={disable} />
      </Row>
    </FormFilterCard>
  );
};
